import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 border-t border-white/5 bg-background">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold tracking-tighter">
              <span className="text-gradient">RAVINDU</span>
              <span className="text-white/50 ml-1">M.</span>
            </h3>
            <p className="text-white/40 text-sm mt-2">© {currentYear} All rights reserved.</p>
          </div>

          <div className="flex items-center gap-6">
            {[
              { icon: FaGithub, href: "https://github.com/rv0627" },
              { icon: FaLinkedin, href: "https://www.linkedin.com/in/ravindu-maleesha-598275256/" },
              { icon: FaEnvelope, href: "mailto:ravindumaleesha077@gmail.com" },
              { icon: FaWhatsapp, href: "https://wa.me/94769831282" }
            ].map((social, i) => (
              <motion.a
                key={i}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -3 }}
                className="text-white/40 hover:text-white transition-colors"
              >
                <social.icon size={20} />
              </motion.a>
            ))}
          </div>

          <div className="text-white/20 text-xs uppercase tracking-[0.2em] font-medium">
            Sri Lanka • Digital Solutions
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
